import { RFIProps } from "@/interfaces/rfi_types";
import { HistoryCardBase, formatDate, formatDateTime } from "./Utils/CardHelper";
import { CategoryIcon } from "./Utils/CategoryIcon";


export function HistoryRFICard({ rfi }: { rfi: RFIProps; }) {
    return (
        <HistoryCardBase key={rfi.RFI_id}>
            <div className="flex justify-between">
                <div className="flex flex-row items-center">
                    <CategoryIcon category={rfi.category} />
                    <h3>RFI #<span className="font-bold"> {rfi.RFI_number}</span> </h3>
                </div>
                <h4>Project:<span className="font-bold"> {rfi.project}</span></h4>
            </div>

            <div className="flex justify-between">
                <p>Assigned to:<span className="font-bold"> {rfi.assigned_to_name}</span></p>
                <p>Received on:<span className="font-bold"> {formatDate(rfi.date_received)}</span></p>
                <p>{rfi.completed_at ? <span className="text-green-700">Completed on: {formatDateTime(rfi.completed_at)}</span> : <span className="text-red-700">Not Completed</span>}</p>
            </div>
        </HistoryCardBase>
    );
}
